import "text-encoding-polyfill";
import Joi from "joi";

const singUpSchema = Joi.object({
	accountType: Joi.string().valid("Responsável", "Estudante").required(),
	name: Joi.string().min(5).max(60).required(),
	email: Joi.string()
		.email({
			tlds: false,
		})
		.required(),
	confirmEmail: Joi.string().valid(Joi.ref("email")).required(),
	password: Joi.string().min(5).max(20).required(),
	confirmPassword: Joi.string().valid(Joi.ref("password")).required(),
	termsAgreed: Joi.boolean().valid(true).required(),
});

export default singUpSchema;
